import React, { useEffect } from "react";
import { Row, Col, Form, Input, Button, Alert } from "antd";
import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  CompassOutlined,
} from "@ant-design/icons";
import axios from "axios";

const ACCENT = "#27b2c4";

const ContactUs = () => {
  const [form] = Form.useForm();
  const [formSuccessMessage, setFormSuccessMessage] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    document.title = "JOJ | Contact Us";
    logUserActivity({ detail: "" });
  }, []);

  const logUserActivity = async ({ detail }) => {
    const tokenString = localStorage.getItem("token");

    try {
      const jsondata = JSON.stringify({
        ScreenID: "4",
        DetailID: "0",
        Detail: detail,
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {})
        .catch((error) => {});
    } catch (err) {}
  };

  const onFinish = (values) => {
    setIsLoading(true);
    setFormSuccessMessage("");
    // Handle form submission logic here
    try {
      setFormSuccessMessage("");
      const listData = {
        Name: values.name,
        ContactNo: values.mobile,
        Message: values.message,
      };

      let config = {
        method: "post",

        url:
          global.config.APIURL.BaseURL + "api/ContactUs/InsertContactUsRequest",
        headers: {
          "Content-Type": "application/json",
        },
        data: listData,
      };

      axios
        .request(config)
        .then((response) => {
          logUserActivity({ detail: "Contact-Us-Requested" });
          setFormSuccessMessage("Request submitted successfully!");
          form.resetFields();
        })
        .catch((error) => {});
    } catch (err) {}
    setIsLoading(false);
  };

  const contactItems = [
    {
      icon: <PhoneOutlined />,
      label: "Phone",
      content: (
        <a href="tel:8000002808" style={{ color: "#1f1f1f" }}>
          80000 02808
        </a>
      ),
    },
    {
      icon: <MailOutlined />,
      label: "Email",
      content: (
        <a href="mailto:admin@jewelsofjoy.in" style={{ color: "#1f1f1f" }}>
          admin@jewelsofjoy.in
        </a>
      ),
    },
    {
      icon: <EnvironmentOutlined />,
      label: "Address",
      content: (
        <>
          Shree Ranchhod Nagar, Bh. Sant Kabir Road, Rajkot, Gujarat
          <br />
          <a
            href="https://maps.app.goo.gl/KQqdjp3pviaJRwTPA"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: ACCENT,
              fontWeight: 500,
              display: "inline-block",
              marginTop: 6,
            }}
          >
            <CompassOutlined style={{ marginRight: 6 }} />
            Show on Map
          </a>
        </>
      ),
    },
  ];

  return (
    <div style={{ background: "#fff" }}>
      <div
        style={{
          maxWidth: 960,
          margin: "0 auto",
          padding: "40px 20px 64px",
        }}
      >
        {/* Heading + intro */}
        <div style={{ textAlign: "center", maxWidth: 680, margin: "0 auto 44px" }}>
          <h1
            style={{
              fontSize: 32,
              fontWeight: 700,
              letterSpacing: -0.5,
              margin: 0,
              color: "#1f1f1f",
            }}
          >
            Contact Us
          </h1>
          <p
            style={{
              marginTop: 16,
              color: "#595959",
              fontSize: 16,
              lineHeight: 1.75,
            }}
          >
            We're here to help! Whether you have questions about products,
            orders, or anything else, feel free to reach out — we'd love to hear
            from you.
          </p>
        </div>

        <Row gutter={[24, 24]}>
          {/* Contact Form */}
          <Col xs={24} md={14}>
            <div
              style={{
                height: "100%",
                padding: "28px 24px",
                borderRadius: 16,
                border: "1px solid #f0f0f0",
                background: "#fff",
              }}
            >
              <h3
                style={{
                  fontSize: 17,
                  fontWeight: 600,
                  margin: "0 0 20px",
                  color: "#1f1f1f",
                }}
              >
                Send us a Message
              </h3>
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
              >
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    { required: true, message: "Please enter your name" },
                  ]}
                >
                  <Input placeholder="Your Name" size="large" />
                </Form.Item>

                <Form.Item
                  name="mobile"
                  label="Mobile Number"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your mobile number",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Enter a valid 10-digit number",
                    },
                  ]}
                >
                  <Input placeholder="Mobile Number" size="large" />
                </Form.Item>

                <Form.Item
                  name="message"
                  label="Message"
                  rules={[
                    { required: true, message: "Please enter your message" },
                  ]}
                >
                  <Input.TextArea placeholder="Your message..." rows={4} />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    size="large"
                    block
                  >
                    Submit
                  </Button>
                </Form.Item>

                {formSuccessMessage ? (
                  <div style={{ marginTop: 16 }}>
                    <Alert message={formSuccessMessage} type="success" showIcon />
                  </div>
                ) : null}
              </Form>
            </div>
          </Col>

          {/* Contact Info */}
          <Col xs={24} md={10}>
            <div
              style={{
                height: "100%",
                padding: "28px 24px",
                borderRadius: 16,
                border: "1px solid #f0f0f0",
                background: "#fafafa",
              }}
            >
              <h3
                style={{
                  fontSize: 17,
                  fontWeight: 600,
                  margin: "0 0 20px",
                  color: "#1f1f1f",
                }}
              >
                Get in Touch
              </h3>

              {contactItems.map((item, idx) => (
                <div
                  key={item.label}
                  style={{
                    display: "flex",
                    gap: 14,
                    alignItems: "flex-start",
                    marginBottom: idx === contactItems.length - 1 ? 0 : 22,
                  }}
                >
                  <div
                    style={{
                      flexShrink: 0,
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(39,178,196,0.1)",
                      color: ACCENT,
                      fontSize: 17,
                    }}
                  >
                    {item.icon}
                  </div>
                  <div style={{ lineHeight: 1.6 }}>
                    <div
                      style={{
                        fontWeight: 600,
                        color: "#1f1f1f",
                        marginBottom: 2,
                      }}
                    >
                      {item.label}
                    </div>
                    <div style={{ color: "#595959", fontSize: 14.5 }}>
                      {item.content}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ContactUs;
